import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "./../commonBaseApiSlice";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AuthData } from "./authSlice";

export type Credentials = {
  clientid: string;
  username: string;
  password: string;
  ipAddress: string;
};

export type verifyOTPData = {
  username: string;
  otp: string;
  ipAddress: string;
  tenantId: string;
};

export type GenrateToken = {
  code: string;
  clientId: string;
};

export const authApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthData, Credentials>({
      query: (credentials: Credentials) => ({
        url: `/authentication/authenticate?tenantId=${credentials.clientid}`,
        method: "POST",
        body: {
          username: credentials.username,
          password: credentials.password,
          ipAddress: credentials.ipAddress,
        },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/user/forgotpassword?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    verifyResetPass: builder.mutation({
      query: (data) => ({
        url: `/user/verifyresetpasswordlink?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    resetPassword: builder.mutation<AuthData, Credentials>({
      query: (data) => ({
        url: `/user/resetpassword?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    changePassword: builder.mutation<AuthData, Credentials>({
      query: (data) => ({
        url: `/user/changepassword?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    logout: builder.mutation({
      query: ({
        refreshToken,
        isSessionTimeout = false,
      }: {
        refreshToken: string | null;
        isSessionTimeout?: boolean;
      }) => ({
        url: `/authentication/revoke?isSessionTimeout=${isSessionTimeout}`,
        method: "POST",
        body: { refreshToken },
      }),
    }),
    guideUrlApiSlice: builder.mutation({
      query: () => ({
        url: "/user/generateugcode",
        method: "GET",
      }),
    }),
    getAPIVesrion: builder.mutation({
      query: (id) => ({
        url: `/authentication/versioncheck`,
        method: "GET",
      }),
    }),
    verifyOTP: builder.mutation<AuthData, verifyOTPData>({
      query: (payload: verifyOTPData) => ({
        url: `/authentication/validateadminotp?tenantId=${payload.tenantId}`,
        method: "POST",
        body: {
          username: payload.username,
          otp: payload.otp,
          ipAddress: payload.ipAddress,
        },
      }),
    }),
    verifyCaptcha: builder.mutation<any, { captchaValue: string }>({
      query: (payload) => ({
        url: `/authentication/verifycaptchta`,
        method: "POST",
        body: payload,
      }),
    }),
    refreshSession: builder.mutation<AuthData, { accessToken: string | null; refreshToken: string | null }>({
      query: (payload) => ({
        url: `/authentication/refresh`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useChangePasswordMutation,
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useVerifyResetPassMutation,
  useResetPasswordMutation,
  useGuideUrlApiSliceMutation,
  useGetAPIVesrionMutation,
  useVerifyOTPMutation,
  useVerifyCaptchaMutation,
  useRefreshSessionMutation,
} = authApiSlice;

// const apiSlice = commonBaseApiSlice.injectEndpoints({
//   endpoints: (builder) => ({
//     guideApiSlice: builder.mutation({
//       query: () => ({
//         url: "/user/generateugcode",
//         method: "GET",
//       }),
//     }),
//   }),
// });
// export const { useGuideApiSliceMutation } = apiSlice;
// export default apiSlice.reducer;
